import React from 'react';
import PropTypes from 'prop-types';
import deburr from 'lodash/deburr';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';

function getSuggestionValue(suggestion) {
    return suggestion.label;
}

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        color: 'white',
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
});

class AutoSuggestAudit extends React.Component {
    constructor(props) {
        super(props);

        this.redirectToAudit = this.redirectToAudit.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
        this.renderInputComponent = this.renderInputComponent.bind(this);

        this.state = {
            single: '',
            popper: '',
            suggestions: [],
        };
    }

    _handleKeyPress = (e) => {
        if (e.key === 'Enter' && e.target.value) {
            var audit = this.props.suggestions.find(a => (a.company.name && (a.company.name.toLowerCase() === e.target.value.toLowerCase() || a.company.reference === e.target.value || a.reference === e.target.value) ));
            if(audit)
                this.setState({single: ''}, () => {
                    this.redirectToAudit(audit.id)
                })
        }
    };

    redirectToAudit(audit_id){
        this.props.history.replace('/audits/' + audit_id)
    }

    renderSuggestion(suggestion, { query, isHighlighted }) {
        const matches = match(suggestion.label, query);
        const parts = parse(suggestion.label, matches);

        return (
            <MenuItem selected={isHighlighted} component="div" onClick={() => this.redirectToAudit(suggestion.id)}>
                <div>
                    {parts.map((part, index) =>
                        part.highlight ? (
                            <span key={String(index)} style={{ fontWeight: 500 }}>
                              {part.text}
                            </span>
                        ) : (
                            <strong key={String(index)} style={{ fontWeight: 300 }}>
                                {part.text}
                            </strong>
                        ),
                    )}
                </div>
            </MenuItem>
        );
    }

    renderInputComponent(inputProps) {
        const { classes, inputRef = () => {}, ref, ...other } = inputProps;

        return (
            <TextField
                fullWidth
                onKeyPress={this._handleKeyPress}
                InputProps={{
                    inputRef: node => {
                        ref(node);
                        inputRef(node);
                    },
                    classes: {
                        input: classes.input,
                    },
                }}
                {...other}
            />
        );
    }

    getSuggestions(value) {
        const inputValue = deburr(value.trim()).toLowerCase();
        const inputLength = inputValue.length;
        let count = 0;
        return inputLength === 0
            ? []
            : this.props.suggestions.filter(a => a !== null && a !== undefined).map(s => ({label: s.company.name, id: s.id, reference: s.reference, company: {reference: s.company.reference}})).filter(suggestion => {
                const keep =
                    count < 5 && (suggestion.label.slice(0, inputLength).toLowerCase() === inputValue || suggestion.company.reference.slice(0, inputLength).toLowerCase() === inputValue || suggestion.reference.slice(0, inputLength).toLowerCase() === inputValue);

                if (keep) {
                    count += 1;
                }

                return keep;
            });
    }

    handleSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestions: this.getSuggestions(value),
        });
    };

    handleSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    handleChange = name => (event, { newValue }) => {
        if(event.target.type === "text"){
            this.setState({
                [name]: newValue,
            });
        }else{
            this.setState({
                [name]: "",
            });
        }
    };

    render() {
        const { classes } = this.props;

        const autosuggestProps = {
            renderInputComponent: this.renderInputComponent,
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.handleSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.handleSuggestionsClearRequested,
            getSuggestionValue,
            renderSuggestion: this.renderSuggestion,
        };

        return (
            <div className={classes.root}>
                <Autosuggest
                    {...autosuggestProps}
                    inputProps={{
                        classes:{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        },
                        placeholder: 'Rechercher un audit...',
                        value: this.state.single,
                        onChange: this.handleChange('single'),
                    }}
                    theme={{
                        container: classes.container,
                        suggestionsContainerOpen: classes.suggestionsContainerOpen,
                        suggestionsList: classes.suggestionsList,
                        suggestion: classes.suggestion,
                    }}
                    renderSuggestionsContainer={options => (
                        <Paper {...options.containerProps} square>
                            {options.children}
                        </Paper>
                    )}
                />
            </div>
        );
    }
}

AutoSuggestAudit.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AutoSuggestAudit);


// WEBPACK FOOTER //
// ./src/component/utils/AutoSuggestAudit.js